import { gql } from '@apollo/client';

export const GET_ROLES = gql`
  query GET_ROLES($ids: [ID!], $state: State) {
    roles(ids: $ids, state: $state) {
      id
      name
      description
      reportControlType
      disabled
      deleted
      isDefaultRoleForNewUser
      scopes {
        type
        level
      }
      users {
        id
        netId
        disabled
      }
    }
  }
`;

export const ADD_ROLE = gql`
  mutation ADD_ROLE($addRoleInput: AddRoleInput!) {
    addRole(input: $addRoleInput) {
      id
      name
      description
      reportControlType
      isDefaultRoleForNewUser
      disabled
      deleted
      scopes {
        type
        level
      }
    }
  }
`;

export const UPDATE_ROLE = gql`
  mutation UPDATE_ROLE($updateRoleInput: UpdateRoleInput!) {
    updateRole(input: $updateRoleInput) {
      id
      name
      description
      reportControlType
      isDefaultRoleForNewUser
      disabled
      deleted
      scopes {
        type
        level
      }
    }
  }
`;

export const DISABLE_ROLE = gql`
  mutation DISABLE_ROLE($disableRoleInput: DisableRoleInput!) {
    disableRole(input: $disableRoleInput) {
      id
      disabled
    }
  }
`;

export const DELETE_ROLE = gql`
  mutation DELETE_ROLE($deleteRoleInput: DeleteRoleInput!) {
    deleteRole(input: $deleteRoleInput) {
      id
      deleted
    }
  }
`;
